import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          {aboutInfo.title}
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          用心做好免费影视 · 让好电影触手可及
        </p>

        <div className="mt-10 space-y-5">
          {aboutInfo.paragraphs.map((p, i) => (
            <p
              key={i}
              className="text-sm md:text-base text-foreground-700 leading-relaxed"
            >
              {p}
            </p>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center">
            <div className="text-2xl font-bold text-accent-600">12万+</div>
            <p className="mt-1 text-xs text-foreground-500">影视作品</p>
          </div>
          <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center">
            <div className="text-2xl font-bold text-primary-600">200+</div>
            <p className="mt-1 text-xs text-foreground-500">覆盖国家</p>
          </div>
          <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center">
            <div className="text-2xl font-bold text-accent-600">36</div>
            <p className="mt-1 text-xs text-foreground-500">加速节点</p>
          </div>
          <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center">
            <div className="text-2xl font-bold text-primary-600">5000万+</div>
            <p className="mt-1 text-xs text-foreground-500">月活用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}